import { ResponseMapper } from '../../utils/httpclient/response/responsemapper';
import { APIFeatures } from '../util/apifeatures';
import { StatusCodes } from '../util/statuscodes';
import { Strings } from '../../utils/resources/strings';
import { APIProcessorImpl } from './apiProcessor';
import { GetFlashMessageRequest } from '../api/flashmessage/getflashmessages/getflashmessagesrequest';
import { GetFlashMessageResponse, GetFlashMessageResponseDtoImpl } from '../api/flashmessage/getflashmessages/getflashmessagesresponse';
import { FlashMessageBuilder } from '../dto/flashmessage/get/flashmessagebuilder';
import { FlashMessageDto, FlashMessageDtoImpl } from '../dto/flashmessage/get/flashmessagedto';

export class GetFlashMessageAPIProcessorImpl extends APIProcessorImpl<GetFlashMessageRequest, GetFlashMessageResponse>
{
    // execute(): void 
    // {
    //     let response = new GetFlashMessageResponseDtoImpl(APIFeatures.GET_FLASH_MESSAGE, "Get GetFlashMessage Success");
    //       response.setFlashMessageResponseDtos(this.getFlashMessageDto());
        
    //     this.getAPISuccess(response);
    // }
    onSuccess(responseMapper: ResponseMapper): void 
    {
        super.onSuccess(responseMapper);
        try {

            if (+responseMapper.getStatusCode() === StatusCodes.SUCCESS) 
            {
                if(+responseMapper.getStatusCodeOutside() === 0)
                {
                    let response = new GetFlashMessageResponseDtoImpl(APIFeatures.GET_FLASH_MESSAGE, "Get GetFlashMessage Success");
                    response.setFlashMessageResponseDtos(new FlashMessageBuilder(responseMapper.getResponseMap()).buildAll());
                    
                    this.getAPISuccess(response);
                }
                else if(+responseMapper.getStatusCodeOutside() === StatusCodes.NO_CONTENT)
                {
                    this.getAPISuccess(new GetFlashMessageResponseDtoImpl(APIFeatures.GET_FLASH_MESSAGE, this.getContext().getResources().getString(Strings.no_data_list_available)));
                }
                else if(+responseMapper.getStatusCodeOutside() === StatusCodes.INTERNAL_SERVER_ERROR)
                {
                    this.getAPIFailure(new GetFlashMessageResponseDtoImpl(APIFeatures.GET_FLASH_MESSAGE, this.getContext().getResources().getString(Strings.internal_server_error)));
                }
                else
                {
                    this.getAPIFailure(new GetFlashMessageResponseDtoImpl(APIFeatures.GET_FLASH_MESSAGE, responseMapper.getStatusMsg()));
                }
                
            }
            else if(+responseMapper.getStatusCode() === StatusCodes.NO_CONTENT)
            {
                this.getAPISuccess(new GetFlashMessageResponseDtoImpl(APIFeatures.GET_FLASH_MESSAGE, this.getContext().getResources().getString(Strings.no_data_list_available)));
            }
            else if(+responseMapper.getStatusCode() === StatusCodes.INTERNAL_SERVER_ERROR)
            {
                this.getAPIFailure(new GetFlashMessageResponseDtoImpl(APIFeatures.GET_FLASH_MESSAGE, this.getContext().getResources().getString(Strings.internal_server_error)));
            }
        }
        catch (e) {
            this.getAPIFailure(new GetFlashMessageResponseDtoImpl(APIFeatures.GET_FLASH_MESSAGE, this.getContext().getResources().getString(Strings.internal_server_error)));
        }
    }

    onFailure(responseMapper: ResponseMapper): void 
    {
        this.getAPIFailure(new GetFlashMessageResponseDtoImpl(APIFeatures.GET_FLASH_MESSAGE, responseMapper.getStatusMsg()));
    }


    getFlashMessageDto():FlashMessageDto[]
    {
        let data1 = new FlashMessageDtoImpl();
        data1.setMsisdn("");
        data1.setId("1");
        data1.setPlanName("Monthly");
        data1.setStatusMessage("Busy right now , will callback");

        return [data1];
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/processor/getflashmessagesapiprocessor.tsx